import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { PREMIUM_TRACKS, IMG, BOOKING_URLS } from "@/lib/content";

const TRACK_KEYS = ["medicine", "dentistry", "phd"];

export default function PremiumRouter() {
  return (
    <section className="section-pad" data-testid="home-premium-router">
      <div className="container-sp">
        <div className="max-w-3xl">
          <div className="overline">Premium tracks</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight">
            Applying for Medicine, Dentistry or a PhD in Poland?
          </h2>
          <p className="text-[#4A5568] mt-5 max-w-xl">
            These cases are more selective and more institution-specific. You
            deserve deeper, more tailored support — not a generic funnel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-14">
          {PREMIUM_TRACKS.map((t, i) => (
            <motion.div
              key={t.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="group relative overflow-hidden rounded-2xl bg-[#0D1B2A] text-white border border-[#1B2A3D] hover:border-[#D7141A]/50 transition-all"
              data-testid={`premium-track-${i}`}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={IMG[t.image]}
                  alt={t.title}
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                />
              </div>
              <div className="p-7">
                <h3 className="font-serif text-2xl">{t.title}</h3>
                <p className="text-sm text-white/70 mt-3 leading-relaxed">{t.body}</p>
                <ul className="mt-5 space-y-2">
                  {t.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-2 text-sm text-white/85">
                      <Check className="w-4 h-4 text-[#E5444A] mt-0.5 shrink-0" />
                      {pt}
                    </li>
                  ))}
                </ul>
                <a
                  href={BOOKING_URLS[TRACK_KEYS[i]] || BOOKING_URLS.general}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-7 inline-flex items-center gap-1.5 text-[#E5444A] text-sm font-medium"
                  data-testid={`premium-cta-${i}`}
                >
                  {t.cta}
                  <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
